import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    ResolveFn,
    RouterStateSnapshot,
} from '@angular/router';
import { ImageService } from 'lemunzo-shared';
import { catchError, map, Observable, of } from 'rxjs';
import { CaseService } from 'lemunzo-api';

export type FormBackgroundResolverType = {
    backgroundUrl: string | null;
};

export const FALLBACK_BACKGROUND_URL = '/assets/img/fallback-bg.jpg';

/**
 * Resolves the background image URL for registration forms based on the case ID from the query parameters
 *
 * @link https://angular.dev/guide/routing/data-resolvers
 */
export const formBackgroundResolver: ResolveFn<
    Observable<FormBackgroundResolverType>
> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const caseService = inject(CaseService);
    const imageService = inject(ImageService);

    const caseId = Number(route.queryParamMap.get('caseId'));
    if (!Number.isFinite(caseId) || caseId <= 0) {
        return of({ backgroundUrl: FALLBACK_BACKGROUND_URL });
    }

    return caseService
        .getFormBackgroundUrl(caseId, imageService.getAppropriateImageWidth())
        .pipe(
            map((backgroundImageModel) => ({
                backgroundUrl:
                    backgroundImageModel.url || FALLBACK_BACKGROUND_URL,
            })),
            catchError(() => {
                return of({ backgroundUrl: FALLBACK_BACKGROUND_URL });
            })
        );
};
